import { c as _c } from "react/compiler-runtime";
import { slideClasses } from "@/components/collection/overview/styles";
import { ContentBlockCard } from "../ContentBlockCard/ContentBlockCard";
export function FreeformContentCarouselLayout(t0) {
  const $ = _c(4);
  const {
    sections
  } = t0;
  let t1;
  if ($[0] !== sections) {
    t1 = sections?.map(_temp);
    $[0] = sections;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(section, index) {
  return <ContentBlockCard className={slideClasses()} description={section.description} externalUrl={section.externalUrl} key={section.title || index} media={section.media} title={section.title} />;
}